import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { filterStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryFilter";
import { css } from "styled-components";

filterStyles.container = mergeToNew(filterStyles.container, {
    css: css`
        background: ${themeBackgrounds.white};
        padding: 24px;
    `,
});
